export * from './entitlements-service';
export { default as EntitlementsService } from './entitlements-service';
